function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".toast-div_align", shadowSelector, " {top: -68px;}.toast-message_align", shadowSelector, " {height: 0px;display: none;}.more-info-msg_hide", shadowSelector, " {visibility:hidden;display:none;}"].join('');
}
export default [stylesheet];